import * as React from "react";

export const BorderSVG = (props) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="2" fill="white"/>
    <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.25" stroke={props?.color ? props.color : "#7D8492"} stroke-opacity="0.3" stroke-width="1.5"/>
    <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.25" stroke={props?.color ? props.color : "#7D8492"} stroke-width="1.5"/>
    </svg>    
);
